export function safelyConvertToNumber(str) {
    // Use a regular expression to check if the string contains only numeric characters
    if (/^\d+$/.test(str)) {
        // If the string contains only numeric characters, convert it to a number
        return parseInt(str, 10);
    }
    // If the string contains non-numeric characters, return the original string
    return str;
}
